import { z } from "zod";

export const grievanceSchema = z.object({
  department: z.enum(["HR", "Admin", "Support", "Account", "IT"], {
    required_error: "Department is required",
  }),
  // category_id/subcategory_id are opaque encrypted ids from the
  // categories/subcategories APIs now, not plain numbers — just check
  // something was selected, the backend decrypts and validates the rest.
  category_id: z
    .string({ invalid_type_error: "Category is required" })
    .min(1, { message: "Category is required" }),
  subcategory_id: z.preprocess(
    (val) => (val === "" || val === null || val === undefined ? undefined : val),
    z.string().min(1).optional()
  ),
  subject: z.string().min(1, "Subject is required"),
  description: z.string().optional(),
  incident_date: z
    .preprocess((val) => {
      if (val instanceof Date && !isNaN(val)) return val;
      if (typeof val === "string" && val.trim() !== "") {
        const parsed = new Date(val);
        return isNaN(parsed) ? undefined : parsed;
      }
      return undefined;
    }, z.date({
      required_error: "Incident date is required",
      invalid_type_error: "Incident date is required",
    }))
    .refine((date) => date <= new Date(), {
      message: "Incident date cannot be in the future",
    })
    .refine(
      (date) => {
        const threeMonthsAgo = new Date();
        threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
        threeMonthsAgo.setHours(0, 0, 0, 0);
        return date >= threeMonthsAgo;
      },
      { message: "Incident date cannot be older than 3 months" },
    ),
  priority: z.enum(["Low", "Medium", "High"]).optional(),
  confidentiality_level: z.enum(["Normal", "Confidential"]).optional(),
  preferred_resolution: z.string().optional(),
});
